export function clamp(val, min, max) {
	return Math.min(Math.max(val, min), max)
}

export function lerp(from, to, at) {
	return from + ((to - from) * at)
}
